import { c as _c } from "react/compiler-runtime";
import { PageContainer } from '@/components/Templates/PageContainer/PageContainer';
import { Header } from '@/contexts/NavigationContext/NavigationWrapper';
import styled from 'styled-components';
import { Logo } from './Logo';
export const EmptyNavigation = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Header><PageContainer><StyledBar><StyledLogo /></StyledBar></PageContainer></Header>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const StyledBar = styled.div`
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    height: var(--size-masthead-innerHeight);
`;
const StyledLogo = styled(Logo)`
    flex: initial;
`;